<template>
    <div class="pt-3">
        <div v-if="!isSubmited" v-loading="isLoading">
            <div class="text-center" style="width: 100%; max-width: 600px; margin: 0 auto;">
                <h5><strong>Showcase Your Animation - Get {{currentItem.bonusAmount}}{{ currentItem.bonusUnit }} Render Coupon</strong></h5>
                <p style="word-break: break-word;">High-quality animations deserve high-value rewards! Share your video
                    or multi-frame sequence rendered on iRender (10-15 seconds in length) to claim your <strong>{{currentItem.bonusAmount}}{{ currentItem.bonusUnit }}</strong> coupon
                </p>
            </div>
            <div class="mt-6" style="width: 100%; max-width: 700px; margin: 0 auto;">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="200px" label-position="left">
                    <el-form-item label="Username" prop="username">
                        <el-input v-model="ruleForm.username" placeholder="Username" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="Brand name" prop="brandName">
                        <el-input v-model="ruleForm.brandName" placeholder="Brand name"></el-input>
                    </el-form-item>
                    <el-form-item label="Project Name" prop="projectName">
                        <el-input v-model="ruleForm.projectName" placeholder="e.g., Interior Design, Animation, etc."></el-input>
                    </el-form-item>
                    <el-form-item label="Project Brief" prop="projectBrief">
                        <el-input type="textarea" v-model="ruleForm.projectBrief" rows="3"
                            placeholder="Tell us a bit about your concept, tools used (software, render engine), or your rendering time."></el-input>
                    </el-form-item>
                    <el-form-item label="3D Workspace Screenshot" prop="workspaceScreenshot" class="mb-1 mb-on-error">
                        <div class="d-flex align-items-center" style="column-gap: 15px;"> 
                            <el-input v-model="ruleForm.workspaceScreenshot" placeholder="Screenshot.jpg"
                                :disabled="(ruleForm.workspaceScreenshotFile && ruleForm.workspaceScreenshotFile != null)"></el-input>
                            <div v-if="!(ruleForm.workspaceScreenshotFile && ruleForm.workspaceScreenshotFile != null)"> 
                                <label
                                    class="d-inline-block btn btn-primary px-3 text-nowrap mt-1" style="font-size: 0.8rem; padding-block: 0.55rem;">
                                    <input type="file" ref="workspaceScreenshotRef" class="d-none"
                                        @change="(e) => updateFileUrl('workspaceScreenshot', e)"/>
                                    <span>Upload</span>
                                </label>
                            </div>
                            <div v-if="(ruleForm.workspaceScreenshotFile && ruleForm.workspaceScreenshotFile != null)"> 
                                <el-button type="danger" @click="clearFile('workspaceScreenshot')">
                                    Remove
                                </el-button>
                            </div>
                        </div>
                    </el-form-item>
                    <div class="text-muted mb-0" style="line-height: 140%; font-size: 90%; font-style: italic; word-break: keep-all;"> 
                        <p>* Please upload a screenshot of your 3D software interface (e.g., Blender, 3ds Max, C4D, etc.) on iRender showing the project workspace that matches your rendered result. This helps us verify your original work.</p>
                    </div>
                    <el-form-item label="Final Render" prop="videoAnimation" class="mb-1 mb-on-error">
                        <div class="d-flex align-items-center" style="column-gap: 15px;"> 
                            <el-input v-model="ruleForm.videoAnimation" placeholder="Video link or Upload"
                                :disabled="(ruleForm.videoAnimationFile && ruleForm.videoAnimationFile != null)"></el-input>
                            <div v-if="!(ruleForm.videoAnimationFile && ruleForm.videoAnimationFile != null)"> 
                                <label
                                    class="d-inline-block btn btn-primary px-3 text-nowrap mt-1" style="font-size: 0.8rem; padding-block: 0.55rem;">
                                    <input type="file" ref="videoAnimationRef" class="d-none"
                                        @change="(e) => updateFileUrl('videoAnimation', e)"/>
                                    <span>Upload</span>
                                </label>
                            </div>
                            <div v-if="(ruleForm.videoAnimationFile && ruleForm.videoAnimationFile != null)"> 
                                <el-button type="danger" @click="clearFile('videoAnimation')">
                                    Remove
                                </el-button>
                            </div>
                        </div>
                    </el-form-item>
                    <div class="text-muted mt-3 mb-5" style="line-height: 130%; font-size: 90%; font-style: italic; word-break: keep-all;">
                        Note: Our CS team will verify your submission and credit the coupon to your account within 1 hour.
                    </div>
                    <!-- <el-form-item>
                        <div class="text-center mt-2">
                            <button class="primary-button-style-2026 px-12 py-0" @click="submitForm('ruleForm')"
                                type="button">
                                Submit
                            </button>
                        </div>
                    </el-form-item> -->
                </el-form>
                <div class="text-center mb-3">
                    <button class="primary-button-style-2026 px-12 py-2" @click="submitForm('ruleForm')"
                        type="button">
                        Submit
                    </button>
                </div>
            </div>
        </div>
        <div v-if="isSubmited" class="pb-3">
            <div class="text-center" style="width: 100%; max-width: 800px; margin: 0 auto;">
                <div class="mb-5">
                    <img src="/img/checked.svg" height="50"/>
                </div>
                <h5><strong>Success! Your request is being processed.</strong></h5>
                <div class="mt-7">
                    <p style="word-break: break-word;">Thank you for sharing your amazing [work/post] with the iRender community!<br/>
                        Our team is currently verifying your submission.</p>
                    <p style="word-break: break-word;">Your <strong>{{currentItem.bonusAmount}} {{ currentItem.bonusUnit }}</strong> coupon will be manually added to your account within 1 hour.</p>
                </div>
                <div>
                    <el-button @click="$router.push('/dashboard')">
                        Back to Dashboard
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import promotionApi from '@/api/promotionApi';
import { EXECUTE_RESULT } from "@/constant/baseConstant";
export default {
    props: {
        currentItem: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            isSubmited: false,
            isLoading: false,
            ruleForm: {
                username: '',
                brandName: '',
                projectName: '',
                projectBrief: '',
                workspaceScreenshot: '',
                videoAnimation: ''
            },
            rules: {}
        };
    },
    computed: {
        ...mapState({
            user: state => state.auth.user
        }),
    },
    watch: {
        user(){
            this.ruleForm.username = this.user.username;
        }
    },
    created() {
        this.ruleForm.username = this.user.username;
        this.rules = {
            username: [
                { required: true, message: 'Please enter username', trigger: 'blur' },
                { min: 3, message: 'Your username is too short', trigger: 'blur' },
                { max: 20, message: 'Username cannot exceed 20 characters', trigger: 'blur' },
                {
                    pattern: /^[a-zA-Z0-9]{3,20}$/,
                    message: 'Username must be 3-20 characters and contain only letters and numbers',
                    trigger: 'blur'
                }
            ],

            brandName: [
                { required: true, message: 'Please enter brand name', trigger: 'blur' }
            ],

            projectName: [
                { required: true, message: 'Please enter project name', trigger: 'blur' }
            ],

            projectBrief: [
                { required: true, message: 'Please enter project brief', trigger: 'blur' }
            ],

            workspaceScreenshot: [
                { required: true, message: 'Please select workspace screenshot file', trigger: 'change' },
                { validator: this.validateFileOrUrl, trigger: 'change' },
                { validator: this.validateFileExtension, trigger: 'change' },
                { validator: this.validateImageFileSize, trigger: 'change' }
            ],

            videoAnimation: [
                { required: true, message: 'Please select Final render file/link', trigger: 'change' },
                { validator: this.validateFileOrUrl, trigger: 'change' },
                { validator: this.validateMaxFileSize, trigger: 'change' },
                { validator: this.validateFileExtension, trigger: 'change' },
                { validator: this.validateNotDuplicate, trigger: 'change' }
            ]
        }
    },
    methods: {
        validateFileOrUrl(rule, value, callback) {
            if (!value) return callback(new Error('Please select a valid file or link'))

            const isUrl = /^(http|https):\/\/[^ "]+$/.test(value)
            const isFile = this.ruleForm[`${rule.field}File`] instanceof File || typeof this.ruleForm[`${rule.field}File`] === 'string'

            if (!isUrl && !isFile) {
                return callback(new Error('Please select a valid file or link'))
            }

            callback()
        },

        validateImageFileSize(rule, value, callback) {
            if (!this.ruleForm[`${rule.field}File`] || !this.ruleForm[`${rule.field}File`].size) return callback()

            const maxMB = 50
            if (this.ruleForm[`${rule.field}File`].size / 1024 / 1024 > maxMB) {
                return callback(new Error(`Image must be < ${maxMB}MB`))
            }

            callback()
        },

        validateMaxFileSize(rule, value, callback) {
            if (!this.ruleForm[`${rule.field}File`] || !this.ruleForm[`${rule.field}File`].size) return callback()

            const maxMB = 200
            if (this.ruleForm[`${rule.field}File`].size / 1024 / 1024 > maxMB) {
                return callback(new Error(`File must be < ${maxMB}MB`))
            }

            callback()
        },

        validateFileExtension(rule, value, callback) {
            if (!this.ruleForm[`${rule.field}File`] || !this.ruleForm[`${rule.field}File`].name) return callback()

            const forbidden = ['.exe', '.txt', '.msi', '.docx', '.doc', '.xlsx', '.xls', '.html', '.htm', '.js']
            const ext = this.ruleForm[`${rule.field}File`].name.substring(this.ruleForm[`${rule.field}File`].name.lastIndexOf('.')).toLowerCase()
            console.log('ext', ext);
            if (forbidden.includes(ext)) {
                return callback(new Error('File type is not allowed'))
            }

            callback()
        },

        validateNotDuplicate(rule, value, callback) {
            if (value === this.ruleForm.workspaceScreenshot) {
                return callback(new Error('Must not match the workspace screenshot'))
            }

            callback()
        },
        updateFileUrl(propName, e){
            this.ruleForm[`${propName}File`] = e.target.files[0];
            this.ruleForm[`${propName}`] = e.target.files[0].name;
        },
        clearFile(propName) {
            this.ruleForm[`${propName}File`] = null;
            this.ruleForm[`${propName}`] = '';
        },
        async submitCouponShowcase(payload) {
            this.isLoading = true;
            const res = await promotionApi.submitCouponShowcase(this.currentItem.code, payload);
            if (res) {
                const data = res.data;
                if (data.result === EXECUTE_RESULT.SUCCESS) {
                    this.$message.success("Submit successfully!");
                    this.isSubmited = true;
                    this.isLoading = false;
                    this.$emit('onRequestReloadList');
                } else {
                    this.isLoading = false;
                    this.$message.error(data.message || "Submit failed!");
                }
            }
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitCouponShowcase({
                        couponVoucherId: this.currentItem.id,
                        ...this.ruleForm
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        }
    },
    mounted() {
        console.log("currentItem in popup: ", this.currentItem);
    }
}
</script>